export class XSightChartColors {

    static bodyStyles = window.getComputedStyle(document.body);

    static getColors(chartType: string) {
      switch(chartType) {
          case 'BAR' : {
            return XSightChartColors.getChartColors('--bar-chart-colors');
          } case 'DONUT' : {
            return XSightChartColors.getChartColors('--donut-chart-colors');
          } case 'ROW' : {
            return XSightChartColors.getChartColors('--row-chart-colors');
          } case 'STACKED-BAR' : {
            return XSightChartColors.getChartColors('--stacked-bar-chart-colors');
          } case 'GROUPED-BAR' : {
            return XSightChartColors.getChartColors('--grouped-bar-chart-colors');
          }
      }
  }

  static getChartColors (colorVariable: string): string[] {
    const colorList = XSightChartColors.bodyStyles.getPropertyValue(colorVariable).replace(/\s/g, '');
    return colorList.includes(',') ? colorList.split(',') : [colorList];
  }

  static getBackgroundColor() {
    return XSightChartColors.bodyStyles.getPropertyValue('--chart-background-color');
  }

  static getDataLabelColor() {
    return XSightChartColors.bodyStyles.getPropertyValue('--chart-data-label-color');
  }

  static getLegendLabelColor() {
    return XSightChartColors.bodyStyles.getPropertyValue('--chart-legend-label-color');
  }

  static getGridLinesColor() {
    return XSightChartColors.bodyStyles.getPropertyValue('--chart-grid-lines-color');
  }

  static getTooltipBorderColor() {
    return XSightChartColors.bodyStyles.getPropertyValue('--chart-tooltip-border-color');
  }

  static getLegendBorderColor() {
    return XSightChartColors.bodyStyles.getPropertyValue('--did-chart-legend-border-color');
  }

  static getAxisStyleColor() {
    return XSightChartColors.bodyStyles.getPropertyValue('--did-chart-axis-style-color');
  }

  static getAxisGridLineColor(){
    return XSightChartColors.bodyStyles.getPropertyValue('--did-chart-axis-grid-lines-color');
  }

  static getAxisLabelColor(){
    return XSightChartColors.bodyStyles.getPropertyValue('--did-chart-axis-labels-color');
  }

  static getPlotBandsColor(){
    return XSightChartColors.bodyStyles.getPropertyValue('--did-chart-plot-bands-color');
  }

  static getPlotBandsPredictionColor(){
    return XSightChartColors.bodyStyles.getPropertyValue('--did-chart-plot-bands-prediction-color');
  }


  static getPlotBandsLabelColor(){
    return XSightChartColors.bodyStyles.getPropertyValue('--did-chart-plot-bands-label-color');
  }

  static getColor(variable: string) {
    return XSightChartColors.bodyStyles.getPropertyValue(variable);
  }

  static getInactiveColor(){
    return XSightChartColors.bodyStyles.getPropertyValue('--did-chart-inactive-color');
  }

  static getActiveColor(){
    return XSightChartColors.bodyStyles.getPropertyValue('--did-chart-active-color');
  }


}
